// Metric metadata, color constants, tooltip copy, and positioning helpers for VivaScore display.
// Used by VivaViolinChart, MetricBar, and all three feature parts (Review, StudentProgress, StudentSubmissions).

// Colors for VivaScore display — reuses existing viva-classes.css variables.
// TODO: confirm with Krystal that these are the correct colors for VivaScore components.
export const VIVASCORE_COLORS = {
  above: 'var(--viva-green)',   // above class average
  below: 'var(--viva-orange)',  // below class average / highlighted
  peers: 'var(--viva-grey)',    // peer dots in violin chart
}

// Metric definitions in display order, with plain-English tooltip copy for teachers.
// TODO: confirm tooltip wording with Krystal before client-facing release.
// Vocabulary Range and Academic Language are intentionally not listed here — the nlp/
// service still computes and shield still stores them, but VivaScore and every display
// now use only these two (Content Alignment 2/3, Response Fluency 1/3).
export const METRICS = [
  {
    key: 'response_fluency',
    label: 'Response Fluency',
    tooltip: 'How many words per second the student spoke, on average, across their responses.',
  },
  {
    key: 'semantic_sim',
    label: 'Content Alignment',
    tooltip: 'How closely the student\'s responses related to the content of their uploaded paper.',
  },
]

// Mandatory tooltip shown alongside every VivaScore display (verbatim from spec).
export const VIVASCORE_TOOLTIP = 'A VivaScore is relative to the rest of the class. 0 is the class average, so a positive number means the student is above average, while a negative number means below average. Most students score between -2 and +2. A VivaScore may shift slightly as more VIVAs are completed in this class.'

// Converts a z-score to a 0–100 value for CSS positioning (e.g., left: X% on MetricBar tracks).
// Treats ±2.5 as practical extremes and clamps outside that range.
// NOTE: for layout only — VivaScore is always displayed as a z-score, not a percentage.
export function zToPercent(z) {
  return Math.min(100, Math.max(0, (z + 2.5) / 5 * 100))
}
